export const getScoreColor = (value: number | string | null) => {
  if (value === null) return;
  const valueNumber = typeof value === "string" ? parseFloat(value) : value;
  if (valueNumber >= 10) return "red";
  if (valueNumber >= 1.99) return "blue";
  return "purple";
};

export const getScoreColorClass = (value: number | string | null) => {
  const color = getScoreColor(value);
  return {
    border: `border-${color}`,
    outline: `outline-${color}`,
    bg: `bg-${color}`,
  };
};
